<template>
    <div class="ros_footerPage">
        <el-pagination
            class="my_pageSel"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="size"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    data () {
        return {}
    },
    props: {
        total: {
            type: Number,
            default: 0
        },
        size: {
            type: Number,
            default: 0
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.$emit('togglePage', val)
        }
    }
}
</script>

<style scope>
.ros_footerPage{
    display: flex;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/pageination.vue